// external dependencies
import { TabulatorFull } from 'tabulator-tables';

// internal dependencies
import { showToast } from "../../toasts";
import { MONTHS } from "../common/filter-elements";

import { getInitalTransactionData } from "../data/get-transactions";

/**
 * Downloads transaction data based on the selected month.
 * 
 * @param tableObject The table object containing transaction data
 * @param currentMonth The current month as a string
 */
export const downloadTransactionData = (tableObject: TabulatorFull, currentMonth: string): void => {
  const tableDownload = document.querySelector("#download-csv") as HTMLElement;
  const dropdownBtn = document.querySelector("#aafp_dropdown-button-month") as HTMLElement;

  const handleDownload = async () => {
    tableDownload.classList.add("aafp_button-loading");

    try {
      const selectedMonth = dropdownBtn.dataset.value || "0";
      const now = new Date();
      let year = now.getFullYear();

      if (selectedMonth === "99") {
        const fileName = `transaction_${new Date().toLocaleDateString()}_download.csv`;
        tableObject.download("csv", fileName);
      } else if (selectedMonth !== "0" && selectedMonth !== currentMonth) {
        const formattedMonth = (+selectedMonth < 10 ? "0" : "") + selectedMonth;
        const startDate = new Date(`${year}-${formattedMonth}-01 00:00:00`);
        const endDate = new Date(`${year}-${formattedMonth}-${new Date(year, +selectedMonth, 0).getDate()} 23:59:59`);

        const response = await getInitalTransactionData(startDate, endDate);

        const fileName = `transaction_${MONTHS[parseInt((+selectedMonth > 9 ? "" : "0") + +selectedMonth)]}-${year}_download.csv`;
        transactionDownloadToCsv(response, fileName);
      } else if (selectedMonth === currentMonth) {
        const day = now.getDate();
        const dateOne = new Date(`${year}-${currentMonth}-01 00:00:00`);
        const dateTwo = new Date(`${year}-${currentMonth}-${day} 23:59:59`);
        const fileName = `transaction_${MONTHS[parseInt((+selectedMonth > 9 ? "" : "0") + +selectedMonth)]}-${year}_download.csv`;

        const transactionData = await getInitalTransactionData(dateOne, dateTwo);
        if (transactionData) {
          transactionDownloadToCsv(transactionData, fileName);
        }
      } else {
        showToast("aafp_toast-alert", "No month selected for download. Please select a month.");
        console.log("No month selected");
      }
    } catch (error) {
      showToast("aafp_toast-alert", "Error downloading transaction data. Please try again later.");
      console.error("Error downloading transaction data:", error);
    } finally {
      tableDownload.classList.remove("aafp_button-loading");
    }
  };

  tableDownload && tableDownload.addEventListener("click", handleDownload);
};

/**
 * Converts transaction data to CSV format and triggers a download.
 * 
 * @param data The transaction data to be converted to CSV
 * @param fileName The name of the CSV file to be downloaded
 * 
 * @returns void
 */ 
const transactionDownloadToCsv = (data: any, fileName: string): void => {
  const replacer = (key: string, value: any) => value === null ? "" : value;
  const header = Object.keys(data[0]);

  const csv = [
    header.join(","),
    ...data.map((row: any) => header.map((fieldName) => JSON.stringify(row[fieldName], replacer)).join(","))
  ].join("\r\n");

  const hiddenElement = document.createElement("a");
  hiddenElement.setAttribute("href", "data:text/plain;charset=utf-8," + encodeURIComponent(csv));
  hiddenElement.target = "_blank";
  hiddenElement.setAttribute("download", fileName + ".csv");
  hiddenElement.click();
};